import React from 'react'
import { Text } from '@babylon/medkit'
import { Interstitial } from '@/programmes/components/FormV2/types'
import Doctor from './assets/doctor.png'
import Spinner from './Spinner'
import styles from './AutoTransitionInterstitial.module.scss'

const DEFAULT_DURATION = 3

type Props = {
  interstitial: Interstitial
  name: string
  title: string
  body: string
}

const AutoTransitionInterstitial = ({
  interstitial,
  name,
  title,
  body,
}: Props) => (
  <div className={styles.container}>
    <img src={Doctor} alt="doctor" />
    <Text className={styles.name} variant="h3">
      {name}
    </Text>
    <Text className={styles.title} variant="smallBody">
      {title}
    </Text>
    <Text className={styles.body} variant="body">
      {body}
    </Text>
    <Spinner
      width={80}
      duration={interstitial.autoTransitionSeconds || DEFAULT_DURATION}
    />
  </div>
)

export default AutoTransitionInterstitial
